import Aos from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";
import { AiFillGithub } from "react-icons/ai";
import { HiOutlineExternalLink } from "react-icons/hi";
import "./project.css";

const Projects = () => {
  useEffect(() => {
    Aos.init({
      duration: 2000,
    });
  }, []);

  return (
    <div>
      <h1 className="uppercase text-primary my-5 lg:text-2xl font-bold flex justify-center">
        some of my projects
      </h1>
      <div
        data-aos="zoom-in"
        className="grid lg:grid-cols-3 justify-center items-center gap-10 p-10"
      >
        {/* section one */}
        <div className="bg-accent text-base-100 p-2 rounded-lg shadow-xl project-one">
          <div className="project-1"></div>
          <div className="mt-3 text-justify p-2">
            <h2 className="card-title mt-3">Comfort Zone</h2>
            <p className="mt-3">
              Comfort Zone is a fullstack E-commerce web app with login using
              Firebase. Users can buy products, leave reviews, and track their
              orders. Admins have CRUD functionality.
            </p>

            <div className="technology mt-3">
              <span>React.js</span>
              <span>Tailwind CSS</span>

              <span>Node.js</span>
              <span>Express.js</span>
              <span>MongoDB</span>
              <span>Firebase</span>
              <span>Stripe</span>
            </div>

            <div className=" mt-5">
              <a
                href="https://comfort-zone-96375.web.app/"
                target="_blank"
                className="btn btn-primary btn-sm"
              >
                {" "}
                <HiOutlineExternalLink className="text-xl mr-2" /> Live Link
              </a>
              <a
                href="https://github.com/Habibullah6/comfort-zone-client"
                target="blank"
                className="btn btn-primary btn-sm ml-5"
              >
                {" "}
                <AiFillGithub className="text-xl mr-2" /> Github
              </a>
            </div>
          </div>
        </div>

        {/* section two */}

        <div className="bg-accent text-base-100 p-2 rounded-lg shadow-xl">
          <div className="project-2"></div>
          <div className="mt-3 text-justify p-2">
            <h2 className="card-title mt-3">Travelocity</h2>
            <p className="mt-3">
              Travelocity is a full-stack booking service web app with Firebase
              authentication. Users can book hotels, and admins can view booking
              lists, add hotels, and manage the system.
            </p>

            <div className="technology mt-3">
              <span>React.js</span>
              <span>React Bootstrap</span>
              <span>Node.js</span>
              <span>Express.js</span>
              <span>MongoDB</span>
              <span>Firebase</span>
            </div>

            <div className=" mt-5">
              <a
                href="https://travelocity-e4f2f.web.app/"
                target="blank"
                className="btn btn-primary btn-sm"
              >
                {" "}
                <HiOutlineExternalLink className="text-xl mr-2" /> Live Link
              </a>
              <a
                href="https://github.com/Habibullah6/Travelocity-Client"
                target="blank"
                className="btn btn-primary btn-sm ml-5"
              >
                {" "}
                <AiFillGithub className="text-xl mr-2" /> Github
              </a>
            </div>
          </div>
        </div>

        {/* section three */}

        <div className="bg-accent text-base-100 p-2 rounded-lg shadow-xl">
          <div className="project-4"></div>
          <div className="mt-3 text-justify p-2">
            <h2 className="card-title mt-3">Euro Dent</h2>
            <p className="mt-3">
              Euro Dent is a website for a dental clinic. It has multiple pages
              and uses fake data. Users can create an account using their email
              and password or by using their Google account.
            </p>

            <div className="technology mt-3">
              <span>React.js</span>
              <span>React Bootstrap</span>
              <span>CSS</span>
              <span>Bootstrap5</span>
              <span>Firebase</span>
            </div>

            <div className=" mt-5">
              <a
                href="https://euro-dent-1.web.app/"
                target="blank"
                className="btn btn-primary btn-sm"
              >
                {" "}
                <HiOutlineExternalLink className="text-xl mr-2" /> Live Link
              </a>
              <a
                href="https://github.com/Habibullah6/EuroDent"
                target="blank"
                className="btn btn-primary btn-sm ml-5"
              >
                {" "}
                <AiFillGithub className="text-xl mr-2" /> Github
              </a>
            </div>
          </div>
        </div>
        {/* section five */}
        <div className="bg-accent text-base-100 p-2 rounded-lg shadow-xl">
          <div className="project-3"></div>
          <div className="mt-3 text-justify p-2">
            <h2 className="card-title mt-3">Edula</h2>
            <p className="mt-3">
              Edula is a simple multi-page website. On this website, there are
              some routes and its loads fake data. User can register and log in
              with email and password or Google.
            </p>

            <div className="technology mt-3">
              <span>React.js</span>
              <span>React Bootstrap</span>
              <span>CSS</span>
              <span>Bootstrap5</span>
              <span>Firebase</span>
            </div>

            <div className=" mt-5">
              <a
                href="https://edula1.web.app"
                target="blank"
                className="btn btn-primary btn-sm"
              >
                {" "}
                <HiOutlineExternalLink className="text-xl mr-2" /> Live Link
              </a>
              <a
                href="https://github.com/Habibullah6/edula-with-authentication-"
                target="blank"
                className="btn btn-primary btn-sm ml-5"
              >
                {" "}
                <AiFillGithub className="text-xl mr-2" /> Github
              </a>
            </div>
          </div>
        </div>
        <div className="bg-accent text-base-100 p-2 rounded-lg shadow-xl">
          <div className="project-5"></div>
          <div className="mt-3 text-justify p-2">
            <h2 className="card-title mt-3">Astro Peptides</h2>
            <p className="mt-3">
            Astro Peptides is an e-commerce site using WordPress, Elementor, and WooCommerce, offering a seamless experience for premium peptides.
            </p>

            <div className="technology mt-3">
              <span>WordPress</span>
              <span>Elementor Pro</span>
              <span>WooCommerce</span>
              
            
            </div>

            <div className=" mt-5">
              <a
                href="https://nomani.weballly.com/"
                target="blank"
                className="btn btn-primary btn-sm"
              >
                {" "}
                <HiOutlineExternalLink className="text-xl mr-2" /> Live Link
              </a>
              <a
                href="#####"
                target="blank"
                className="btn btn-primary btn-sm ml-5"
              >
                {" "}
                <AiFillGithub className="text-xl mr-2" /> Github
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
